import React, { useMemo, useState } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import { renderField, renderselect, renderTextField } from "../../../../Components/Forms/renders";
import PropTypes from "prop-types";
import SwitcButton from "../../../../Components/Forms/switch";
import TimeSelect from "../../../../Components/Forms/time";
import MultiSelectDagen from "../../../../Components/Forms/multiselect";
import SneaTabs from "../../../../Components/SneaTabs";

const SensorEditForm = ({ handleSubmit, activeTab, setActiveTab }) => {
  const requiredValidator = useMemo(() => required(), []);

  const handleTabChange = (tabId, index) => {
    setActiveTab(index);
  };

  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          {/* SNEAT TABS */}
          <SneaTabs
            tabs={[
              {
                id: 'algemeen',
                label: 'Algemeen',
                icon: 'bx bx-info-circle me-2',
                content: (
                  <div className="row g-4">
                    <div className="col-md-8">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-transparent border-bottom-0 pb-0">
                          <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                            <i className="bx bx-info-circle me-2" style={{ color: '#696cff' }}></i>
                            Profiel Informatie
                          </h5>
                        </div>
                        <div className="card-body pt-3">
                          <Field name="naam" type="input" validate={[required()]} component={renderField} label="Naam Gasten profiel" />
                          <Field name="beschrijving" type="input" component={renderTextField} label="Beschrijving profiel (optioneel)" />
                          <Field name="isStandaard" type="input" component={SwitcButton} label="Dit is het standaard profiel" />
                          <Field
                            name="standplaatsCategorie"
                            component={renderselect}
                            label="Gekoppelde Standplaats Categorie (optioneel)"
                            options={{
                              '': 'Geen categorie gekoppeld',
                              // Hier zouden de categorien moeten komen
                            }}
                          />
                          <Field
                            name="precedence"
                            component={renderselect}
                            label="Prioriteit bij conflicten"
                            options={{
                              'gast': 'Gast instellingen hebben voorrang',
                              'categorie': 'Categorie instellingen hebben voorrang'
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-transparent border-bottom-0 pb-0">
                          <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                            <i className="bx bx-time me-2" style={{ color: '#696cff' }}></i>
                            Check-in & Check-out
                          </h5>
                        </div>
                        <div className="card-body pt-3">
                          <Field name="minaantaldagen" type="input" component={renderField} label="Minimaal aantal dagen" />
                          <Field name="inchecktijd" type="number" component={TimeSelect} label="Check-in tijd" />
                          <Field name="uitchecktijd" type="number" component={TimeSelect} label="Check-out tijd" />
                          <Field name="autouitcheck" type="input" component={SwitcButton} label="Automatische uitcheck" />
                        </div>
                      </div>
                    </div>
                  </div>
                )
              },
              {
                id: 'stroom',
                label: 'Stroom & Tarieven',
                icon: 'bx bx-bolt me-2',
                content: (
                  <div className="row g-4">
                    <div className="col-md-6">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-transparent border-bottom-0 pb-0">
                          <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                            <i className="bx bx-euro me-2" style={{ color: '#28c76f' }}></i>
                            Tarieven
                          </h5>
                        </div>
                        <div className="card-body pt-3">
                          <Field name="prijs" type="number" component={renderField} label="Prijs per kWh (€)" />
                          <Field name="minimaalkwh" type="number" component={renderField} label="Minimaal aantal kWh per boeking" />
                          <Field name="kwkinclusief" type="number" component={renderField} label="Inclusief kWh per dag" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-transparent border-bottom-0 pb-0">
                          <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                            <i className="bx bx-bolt me-2" style={{ color: '#ff9f43' }}></i>
                            Stroom Instellingen
                          </h5>
                        </div>
                        <div className="card-body pt-3">
                          <Field name="instellenkwh" type="input" component={SwitcButton} label="kWh instelling verplicht" />
                          <Field name="instellenamp" type="input" component={SwitcButton} label="Ampères kunnen worden ingesteld" />
                          <Field name="afwijkingAmpere" type="number" component={renderField} label="Toegestane ampèrage afwijking" />
                          <Field name="schakelen.in" type="input" component={SwitcButton} label="Gasten mogen stroom inschakelen" />
                          <Field name="schakelen.uit" type="input" component={SwitcButton} label="Gasten mogen stroom uitschakelen" />
                          <Field name="sendalert" type="input" options={[50, 60, 70, 80, 90]} component={MultiSelectDagen} label="Meldingen bij verbruik (%)" />
                        </div>
                      </div>
                    </div>
                  </div>
                )
              },
              {
                id: 'betalingen',
                label: 'Betalingen',
                icon: 'bx bx-credit-card me-2',
                content: (
                  <div className="row g-4">
                    <div className="col-md-12">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-transparent border-bottom-0 pb-0">
                          <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                            <i className="bx bx-credit-card me-2" style={{ color: '#ff9f43' }}></i>
                            Algemene Betalingsinstellingen
                          </h5>
                        </div>
                        <div className="card-body pt-3">
                          <Field name="betalen" type="input" component={SwitcButton} label="Betaling voor stroom verplicht (legacy)" />
                          <Field name="oprekening" type="input" component={SwitcButton} label="Betaling op rekening (jaarplaatsen)" />
                        </div>
                      </div>
                    </div>
                  </div>
                )
              },
              {
                id: 'app',
                label: 'App',
                icon: 'bx bx-mobile-alt me-2',
                content: (
                  <div className="row g-4">
                    <div className="col-md-6">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-transparent border-bottom-0 pb-0">
                          <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                            <i className="bx bx-mobile-alt me-2" style={{ color: '#696cff' }}></i>
                            App Functionaliteit
                          </h5>
                        </div>
                        <div className="card-body pt-3">
                          <Field name="app.vertrekdatumwijzigen" type="input" component={SwitcButton} label="Vertrekdatum wijzigen" />
                          <Field name="app.uitchecken" type="input" component={SwitcButton} label="Zelf uitchecken" />
                          <Field name="app.qr" type="input" component={SwitcButton} label="QR code scannen" />
                          <Field name="app.openRegistratie" type="input" component={SwitcButton} label="Open registratie mogelijk" />
                          <Field name="app.reserveringssysteem" type="input" component={SwitcButton} label="Reserveringssysteem toegang" />
                          <Field name="app.reserveringMaken" type="input" component={SwitcButton} label="Reservering maken" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-transparent border-bottom-0 pb-0">
                          <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                            <i className="bx bx-credit-card me-2" style={{ color: '#28c76f' }}></i>
                            App Betalingen
                          </h5>
                        </div>
                        <div className="card-body pt-3">
                          <Field name="app.betalen" type="input" component={SwitcButton} label="Betaling via app mogelijk" />
                          <Field
                            name="app.betaalmethode"
                            component={renderselect}
                            label="App Betaalmethode"
                            options={{
                              'mollie': 'Mollie',
                              'paynl': 'Pay.nl'
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )
              },
              {
                id: 'kiosk',
                label: 'Kiosk',
                icon: 'bx bx-desktop me-2',
                content: (
                  <div className="row g-4">
                    <div className="col-md-6">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-transparent border-bottom-0 pb-0">
                          <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                            <i className="bx bx-desktop me-2" style={{ color: '#8b5cf6' }}></i>
                            Kiosk Functionaliteit
                          </h5>
                        </div>
                        <div className="card-body pt-3">
                          <Field name="kiosk.vertrekdatumwijzigen" type="input" component={SwitcButton} label="Vertrekdatum wijzigen" />
                          <Field name="kiosk.uitchecken" type="input" component={SwitcButton} label="Zelf uitchecken" />
                          <Field name="kiosk.qr" type="input" component={SwitcButton} label="QR code scannen" />
                          <Field name="kiosk.urlEnable" type="input" component={SwitcButton} label="URL Kiosk inschakelen" />
                          <Field name="kiosk.timeout" type="number" component={renderField} label="Timeout (seconden)" />
                          <Field name="kiosk.url" type="url" component={renderField} label="URL Kiosk" placeholder="https://kiosk.example.com" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-transparent border-bottom-0 pb-0">
                          <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                            <i className="bx bx-credit-card me-2" style={{ color: '#ea5455' }}></i>
                            Kiosk Betalingen
                          </h5>
                        </div>
                        <div className="card-body pt-3">
                          <Field name="kiosk.betalen" type="input" component={SwitcButton} label="Betaling via kiosk mogelijk" />
                          <Field
                            name="kiosk.betaalmethode"
                            component={renderselect}
                            label="Kiosk Betaalmethode"
                            options={{
                              'mollie': 'Mollie',
                              'paynl': 'Pay.nl'
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )
              }
            ]}
            defaultActiveTab={activeTab}
            onTabChange={handleTabChange}
          />

          {/* SUBMIT KNOP */}
          <div className="pull-left submit mt-4">
            <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Update" />
          </div>
        </div>
      </form>
    </div>
  );
};

SensorEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  activeTab: PropTypes.number.isRequired,
  setActiveTab: PropTypes.func.isRequired,
};

const ReduxFormSensorEdit = reduxForm({
  form: "gasteprofiel_edit", // a unique identifier for this form
})(SensorEditForm);

const mapStateToProps = (state) => ({
  initialValues: state.gastenverbruik.gastenprofiel, // pull initial values from account reducer
});

export default connect(mapStateToProps)(ReduxFormSensorEdit);
